export default __webpack_public_path__ + "static/media/heineken.5ada33ee.jpeg";